// Small pill switch, same look as the "Include Pending" toggle on the Team
// Performance screen. When ON, report numbers count deals still in flight
// (under contract / pending) alongside closed ones.
function IncludePendingToggle({ on, onToggle }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      title={
        on
          ? "Showing closed + pending deals. Click to switch to closed only."
          : "Showing closed deals only. Click to include pending."
      }
      className="inline-flex items-center gap-2 text-[13px] font-medium text-slate-600 hover:text-slate-900"
    >
      <span
        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
          on ? "bg-[#1E293B]" : "bg-slate-300"
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            on ? "translate-x-4" : "translate-x-0.5"
          }`}
        />
      </span>
      <span>Include Pending</span>
      {on && (
        <span className="text-[11px] font-semibold bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full">
          Pending included
        </span>
      )}
    </button>
  );
}

export default IncludePendingToggle;
